import React, { type FC, useState } from 'react';
import { Button } from '@goldbely/explore-component-library';

import { LazyImage } from 'src/explore/elements/LazyImage';
import { NotificationForm } from 'src/shoppe/elements/NotificationForm';

import styles from './index.module.sass';

type IProductProps = {
  id: number;
  comingSoon?: boolean;
  description: string;
  hideDescription?: boolean;
  href: string;
  src: string;
  soldOut?: boolean;
  title: string;
};

type TagProps = {
  tagName: string;
  children: React.ReactNode;
  [key: string]: any;
};

const Tag = ({ tagName, children, ...props }: TagProps ) => 
  React.createElement( tagName, props, children );

export const Product: FC<IProductProps> = ({  
  id,
  comingSoon = false,
  description,
  hideDescription = false,
  href,
  src,
  soldOut = false,
  title,
}) => {
  const [ notifyModal, setNotifyModal ] = useState<boolean>( false );
  const isSoldOut = soldOut || comingSoon;
  const buttonText = isSoldOut ? 'Join the Waitlist' : 'Shop Now';
  const overlayText = comingSoon ? (
    <Button className={styles.overlayButton} type="button" outline>
      Join the Waitlist
    </Button>
  ) : (
    'Sold Out'
  );

  const handleClick = () => {
    if ( isSoldOut ) {
      setNotifyModal( true );
    }
  };

  const tagName = isSoldOut ? 'div' : 'a';
  const hrefAttr = isSoldOut ? undefined : href;
  const onClick = isSoldOut ? handleClick : undefined;
  const props = { href: hrefAttr, onClick };

  return (
    <>
      <Tag tagName={tagName} className={styles.link} {...props}>
        <div className={styles.imageContainer}>
          {isSoldOut && <div className={styles.overlay}>{overlayText}</div>}
          <LazyImage className={styles.image} src={src} />
        </div>
        <div className={styles.content}>
          <h2 className={styles.title}>{title}</h2>
          {!hideDescription && <div className={styles.description}>{description}</div>}
          <Button className={styles.button} type="button" outline>
            {buttonText}
          </Button>
        </div>
      </Tag>
      <NotificationForm
        open={notifyModal}
        productID={id}
        onClose={() => setNotifyModal( false )}
        showSubscribeCheckbox={false}
      />
    </>
  );
};
